<template>
  <div>
     
  <header
    id="kt_header_mobile"
    class="fixed-top bg-primary"
    v-bind:class="headerClasses"
  >     
   <div v-if="configuracion.activo" class="mensaje-global">{{ configuracion.valor }}</div>
      <b-navbar class="navbar navbar-expand-lg navbar-dark" toggleable="lg" v-if="user.codigoRol=='Cliente'"  >
        <b-navbar-brand class="navbar-brand logo-brand" to="/dashboard">
        </b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
           <b-nav-item to="/dashboard" nav-link exact exact-active-class="active">Pagos</b-nav-item>
      <b-nav-item to="/payment/orders" nav-link exact exact-active-class="active">Pedidos </b-nav-item>
          <b-nav-item to="/payment/credit" nav-link exact exact-active-class="active">Abonos </b-nav-item>
          
      <b-nav-item to="/payment/history" nav-link exact exact-active-class="active">Historial de Pagos </b-nav-item>
      <b-nav-item-dropdown text="Opciones" nav-link exact exact-active-class="active">
            <b-dropdown-item to="/profile">Mi Cuenta</b-dropdown-item>
            <b-dropdown-item  @click="modalError=true">Solicitar soporte</b-dropdown-item>
            <b-dropdown-item  @click="onLogout">Salir</b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
      <b-navbar class="navbar navbar-expand-lg navbar-dark" toggleable="lg" v-if="user.codigoRol=='Administrador'"  >
        <b-navbar-brand class="navbar-brand" to="/dashboard-executive"><img class="mb-2" src="/media/img/logotipo.svg" alt="" width="120"></b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">      
            <b-nav-item to="/management/clients" nav-link exact exact-active-class="active">Clientes </b-nav-item>
            <b-nav-item to="/management/clients/client" nav-link exact exact-active-class="active">Pagos Clientes </b-nav-item>
            <b-nav-item to="/management/users" nav-link exact exact-active-class="active">Ejecutivos </b-nav-item>
             <b-nav-item to="/management/companies-client" nav-link exact exact-active-class="active">Empresas Clientes </b-nav-item>
            <b-nav-item to="/management/companies" nav-link exact exact-active-class="active">Empresas Socofar </b-nav-item>
            <b-nav-item to="/management/notifications" nav-link exact exact-active-class="active">Notificaciones </b-nav-item>
            <b-nav-item to="/management/listaNegra" nav-link exact exact-active-class="active">Lista Negra </b-nav-item>
            <b-nav-item to="/management/envioDocumentos" nav-link exact exact-active-class="active">Documentos Enviados </b-nav-item>

          <b-nav-item to="/payment/history-payment" nav-link exact exact-active-class="active">Historial de Pagos </b-nav-item>
      <b-nav-item-dropdown text="Opciones" nav-link exact exact-active-class="active">
            <b-dropdown-item to="/profile">Mi Cuenta</b-dropdown-item>
            <b-dropdown-item to="/management/config">Mensaje Global </b-dropdown-item>  
            <b-dropdown-item to="/payment/history-payment-error-ebso">Revisar Transacciones con Error Ebso</b-dropdown-item>
            <b-dropdown-item to="/payment/history-payment-error">Revisar Transacciones con Error</b-dropdown-item>
            <b-dropdown-item to="/management/quadrature">Cuadraturas</b-dropdown-item>
            <b-dropdown-item to="/management/quadrature-query">Consulta Cuadraturas</b-dropdown-item>
            <b-dropdown-item to="/management/quadrature-notfound">Cuadraturas no Encontradas</b-dropdown-item>
            <b-dropdown-item to="/management/quadrature-bam">Monitor</b-dropdown-item>
            <b-dropdown-item to="/management/quadrature-report">Reportes</b-dropdown-item>
            <b-dropdown-item  @click="modalError=true">Solicitar soporte</b-dropdown-item>
            <b-dropdown-item  @click="onLogout">Salir</b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>

      <b-navbar class="navbar navbar-expand-lg navbar-dark" toggleable="lg" v-if="user.codigoRol=='Ejecutivo'"  >
        <b-navbar-brand class="navbar-brand" to="/dashboard-executive"><img class="mb-2" src="/media/img/logotipo.svg" alt="" width="120"></b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">

            <!-- menu ejecutivo antiguo -->
          <!-- <b-nav-item to="/payment/history" nav-link exact exact-active-class="active">Historial de Pagos </b-nav-item> -->

          <!--Solicitaron que el ejecutivo pudiera ver lo mismo que los admin-->
          <b-nav-item to="/payment/history-payment" nav-link exact exact-active-class="active">Historial de Pagos </b-nav-item> 
          <b-nav-item to="/management/clients" nav-link exact exact-active-class="active">Clientes </b-nav-item>
          <b-nav-item to="/management/notifications" nav-link exact exact-active-class="active">Notificaciones </b-nav-item>

            <!-- Menu que podra ver el rol Ejecutivo (Realizando pruebas) -->

            <!-- <b-nav-item to="/management/clients" nav-link exact exact-active-class="active">Clientes </b-nav-item>
            <b-nav-item to="/management/notifications" nav-link exact exact-active-class="active">Notificaciones </b-nav-item>
          <b-nav-item to="/payment/history" nav-link exact exact-active-class="active">Historial de Pagos </b-nav-item>
            <b-dropdown-item to="/management/quadrature">Cuadraturas</b-dropdown-item>
            <b-dropdown-item to="/management/quadrature-query">Consulta Cuadraturas</b-dropdown-item>
            <b-dropdown-item to="/management/quadrature-notfound">Cuadraturas no Encontradas</b-dropdown-item>
              <b-dropdown-item to="/management/quadrature-bam">Monitor</b-dropdown-item> -->


          <b-nav-item-dropdown text="Opciones" nav-link exact exact-active-class="active">
            <b-dropdown-item to="/profile">Mi Cuenta</b-dropdown-item>
            <b-dropdown-item  @click="modalError=true">Solicitar soporte</b-dropdown-item>
            <b-dropdown-item  @click="onLogout">Salir</b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </header>
    <b-modal id="sidebar-right" hide-footer v-model="modalError" title="Declarar Problema">
        <div class="px-3 py-2">
          <p>
           ¿Se ha presentado un error?<br/>
           Por favor informanos a través de este formulario y lo resolveremos a la brevedad.
          </p>
          
          <div class="form-label-group">
            <label for="titulo">Principal Problema</label>
            <b-form-input
              autocomplete="off"
              class="form-control"
              id="titulo"
              name="titulo"
              placeholder="Ingrese el error presentado"
              v-model="tituloError"
              autofocus
            ></b-form-input>
          </div>
          <div class="form-label-group">
            <label for="titulo">Describe brevemente el problema {{client}}</label>
            <b-form-textarea
                id="textarea"
                v-model="descripcionError"
                placeholder="Describe el problema"
                rows="3"
                max-rows="6"
              ></b-form-textarea>
          </div>
          <button @click="sendTask"
            class="btn btn-primary align-self-center"
          >
            Notificar
          </button>
        </div>
      </b-modal>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { mapGetters } from "vuex";
import StyleService from "@/core/services/style.service";
import KTLayoutHeaderTopbar from "@/assets/js/layout/base/header-topbar.js";
import { LOGOUT } from "@/core/services/store/auth.module";
import { CREATE_TASK_JIRA } from "@/core/services/store/jira.module";
const customTheme = (css) => import(`@/assets/sass/custom-${css}.scss`);
import { GET_CONFIGURACION } from "@/core/services/store/configuracion.module";
export default {
  name: "KTHeaderMobile",
  components: {},
  props: {
    id: String
  },
  data() {
    return {
      tituloError:null,
      descripcionError:null,
      modalError:false,
      cssId:'',
      configuracion:{}
    }

  },
  mounted() {
    // Init Header Topbar For Mobile Mode
    this.obtenerConfiguracion()
    KTLayoutHeaderTopbar.init(this.$refs["kt_header_mobile_topbar_toggle"]);
  },
  methods: {
     obtenerConfiguracion() {
    this.$store
      .dispatch(GET_CONFIGURACION, "MENSAJEGLOBAL")
      .then((response) => {
        (this.configuracion = response), (this.loading = false);
      });
  },
    sendTask() {
      if (this.tituloError==null || this.tituloError=='') {
        return;
      }
      const descripcionError = `${this.user.nombreEmpresa} . Declara Error: \n\t ${this.descripcionError}`;
      this.$store
        .dispatch(CREATE_TASK_JIRA, { project:'', module:'', title:this.tituloError, description:descripcionError })
        .then(() => {
          this.modalError = false;
          this.tituloError=null;
          this.descripcionError=null;
        });
    },
    onLogout() {
      this.$store
        .dispatch(LOGOUT)
        .then(() => this.$router.push({ name: "login" }));
    }
  },
  created() {
    const currentStyle = StyleService.getCss();
    if(currentStyle!==undefined){
      customTheme(currentStyle);
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    }),
    ...mapGetters(["layoutConfig", "getClasses"]),
    
    /**
     * Get header logo
     * @returns {string}
     */
    headerLogo() {
      /*if(this.user.logo==''){
        return process.env.BASE_URL + "media/img/icon-munnich.svg";
      }*/
      //return process.env.BASE_URL + "media/img/logotipo-munnich.svg";
      return process.env.BASE_URL + this.layoutConfig("self.logo.default");
    },

    /**
     * Get classes for mobile header
     * @returns {null|*}
     */
    headerClasses() {
      const classes = this.getClasses("header_mobile");
      if (typeof classes !== "undefined") {
        return classes.join(" ");
      }
      return null;
    },

    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    }
  }
};
</script>
<style>
.v-badge__badge {
    right: auto;
}
.green {
    background-color: #4caf50!important;
    border-color: #4caf50!important;
}
.v-badge__badge {
      bottom: calc(100% - 1px);
    left: calc(100% - 2px);
    right: auto;
    top: auto;

    border-radius: 10px;
    color: #fff;
    font-size: 12px;
    height: 20px;
    letter-spacing: 0;
    min-width: 20px;
    padding: 4px 6px;
    pointer-events: auto;
    position: absolute;
    text-align: center;
    text-indent: 0;
    top: auto;
    transition: .3s cubic-bezier(.25,.8,.5,1);
    white-space: nowrap;
}

.nav-link{
  font-size: 14px
  /* font-size: 12px;
  white-space: nowrap; */
}

/* .navbar-nav{
      display: flex;
    align-items: center;
} */

.mensaje-global {
    background: rgb(245, 158, 11);
    color: black;
    font-size: 1.1rem;
    font-weight: 500;
    padding: 15px 20px;
    width: 100%;
    text-align: center;
    margin: 0;
    position: relative;
    z-index: 9999999;
  }
</style>